export enum DATE_FILTER {
  PAST = 'past',
  FUTURE = 'future',
}
